import { Button, Typography } from '@mui/material';

import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import clsx from 'clsx';

type ExtendedWarrantyPageHeaderProps = {
    className?: string | undefined;
    title: React.ReactNode | string;
    subtitle: React.ReactNode | string;
    handleModalOpen?: () => void;
    feedbackEnabled?: boolean;
};

export const ExtendedWarrantyPageHeader = ({
    className,
    title = 'Extended Warranty',
    subtitle = 'Registered Installations',
    handleModalOpen,
    feedbackEnabled,
}: ExtendedWarrantyPageHeaderProps) => {
    return (
        <div className={clsx('flex flex-col md:flex-row md:items-center gap-5', className)}>
            <div>
                <Typography variant="h5" fontWeight={700}>
                    {title}
                </Typography>
                <Typography variant="body1" fontWeight={500}>
                    {subtitle}
                </Typography>
            </div>
            {feedbackEnabled && (
                <div className="ml-auto">
                    <Button
                        color="white"
                        startIcon={<EmailOutlinedIcon />}
                        size="large"
                        disableElevation={false}
                        className="!rounded-sm"
                        onClick={handleModalOpen}
                    >
                        FEEDBACK
                    </Button>
                </div>
            )}
        </div>
    );
};
